import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';

export interface APITypes {
  method: 'GET' | 'PUT' | 'POST' | 'DELETE';
  endpoint: string;
  baseURL: string;
}

export function vehicleSaveAPIType(fleetId: string, dealerId: string, vehicleId?: string): APITypes {
  const method: APITypes['method'] = vehicleId ? 'PUT' : 'POST';
  const endpoint: string = vehicleId
    ? `vehicles/${fleetId}/${vehicleId}?dealer_id=${dealerId}`
    : `vehicles/${fleetId}?dealer_id=${dealerId}`;
  return { method, endpoint, baseURL };
}

export function vehiclesDetailAPIType(fleetId: string, vehicleId?: string): APITypes {
  return { method: 'GET', baseURL, endpoint: fleetId && vehicleId ? `vehicles/${fleetId}/${vehicleId}` : '' };
}

export function vehiclesDeleteAPIType(fleetId: string, vehicleId: string | number): APITypes {
  return { method: 'DELETE', baseURL, endpoint: fleetId && vehicleId ? `vehicles/${fleetId}/${vehicleId}` : '' };
}

export function vehiclesListingAPIType(fleetId: string, multiShipTos: string[] | undefined): APITypes {
  if (multiShipTos)
    return { method: 'GET', baseURL, endpoint: `vehicles/multiple?locations=${multiShipTos.join(',')}` };
  return { method: 'GET', baseURL, endpoint: fleetId ? `vehicles/${fleetId}` : '' };
}

export function yearsAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'ymmos/years' };
}

export function makesAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'ymmos/makes' };
}

export function modelsAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'ymmos/models' };
}

export function optionsAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'ymmos/options' };
}

export function tireSizesAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'ymmos/sizes' };
}

export function customTireSizeAPIType(): APITypes {
  return { method: 'GET', baseURL, endpoint: 'customTireSize/custom' };
}
